import { defineComponent as _defineComponent } from 'vue'
import { computed } from '@nuxtjs/composition-api';
import { CdnImg } from '@webplatform/cdn-image';
import { useBreakpoint } from '~/composables';
import { handleImageSrc, handleImageAlt } from '~/helpers';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';

interface Props {
  data?: { id?: string; items: any };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SoftwareCategoryReviewsSlider',
  props: {
    data: { default: () => ({ items: [] }) }
  },
  setup(__props: any) {

const props = __props as { data: { id?: string; items: any } };



const { isBiggerThanBreakpoint: isDesktop } = useBreakpoint('lg');

const swiperOptions = {
  navigation: {
    prevEl: '.nav-prev',
    nextEl: '.nav-next',
  },
  lazy: {
    enabled: true,
    checkInView: true,
    loadPrevNext: true,
    loadOnTransitionStart: true,
  },
  loop: true,
  slidesPerView: 1,
  spaceBetween: 16,
  observer: true,
};

const showNav = computed(
  () => isDesktop.value && props.data?.items?.length > 1,
);

return { __sfc: true,props, isDesktop, swiperOptions, showNav, CdnImg, handleImageSrc, handleImageAlt, Swiper, SwiperSlide }
}

})